export class ShovalEnrollment {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "instanceId",
            "baseName": "instanceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "ShovalEnrollmentStateEnum",
            "format": ""
        },
        {
            "name": "commandsQueueUrl",
            "baseName": "commandsQueueUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "heartbeatAt",
            "baseName": "heartbeatAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "needsBaseline",
            "baseName": "needsBaseline",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "volumes",
            "baseName": "volumes",
            "type": "Array<ShovalEnrollmentVolume>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ShovalEnrollment.attributeTypeMap;
    }
    constructor() {
    }
}
export var ShovalEnrollmentStateEnum;
(function (ShovalEnrollmentStateEnum) {
    ShovalEnrollmentStateEnum["Enrolling"] = "ENROLLING";
    ShovalEnrollmentStateEnum["Active"] = "ACTIVE";
    ShovalEnrollmentStateEnum["Degraded"] = "DEGRADED";
    ShovalEnrollmentStateEnum["Detaching"] = "DETACHING";
})(ShovalEnrollmentStateEnum || (ShovalEnrollmentStateEnum = {}));
